import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Auth, SetAuth } from "types";
import { setAuth } from "configs/store/auth/actions";

type UseAuth = () => [Auth, SetAuth];

const useAuth: UseAuth = () => {
  const dispatch = useDispatch();

  const auth = useSelector((state: any) => state.auth, shallowEqual);
  const updateAuth = (newAuth: any): void => {
    dispatch(setAuth(newAuth));
  };

  return [auth, updateAuth];
};

export default useAuth;
